export default "__VITE_ASSET__hySnjv5C__"